import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';

import './i18n';
import './index.css';
import App from './App';
import store from './app/store';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('app')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Setup service worker for the client
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js', {
        scope: '/',
      });
      if (registration.installing) {
        console.log('Service worker installing');
      } else if (registration.waiting) {
        console.log('Service worker installed');
      } else if (registration.active) {
        console.log('Service worker active');
      }
    } catch (error) {
      console.error(`Registration failed with ${error}`);
    }
  }
};

const unregisterServiceWorker = async () => {
  // `navigator.serviceWorker` only exists in a secure context - HTTPS, or localhost/127.0.0.1.
  // Served over plain HTTP on any other hostname it is undefined, so this has to guard the same
  // way registerServiceWorker above does. There is nothing to unregister in that case anyway:
  // a context that cannot register a service worker cannot be holding a stale one.
  if (!('serviceWorker' in navigator)) {
    return;
  }
  try {
    console.log('Service worker uninstalling');
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      console.log('Service worker uninstalled');
      for (const registration of registrations) {
        registration.unregister();
      }
    });
  } catch (error) {
    console.error(`unregisterServiceWorker failed with ${error}`);
  }
};

// registerServiceWorker();
unregisterServiceWorker();
